import { cn } from "../../lib/utils"

interface LoadingSpinnerProps {
  className?: string
  size?: number
}

export function LoadingSpinner({ className, size = 24 }: LoadingSpinnerProps) {
  return (
    <div
      className={cn("animate-spin", className)}
      style={{
        width: size,
        height: size,
        border: "2px solid hsl(var(--border))",
        borderTop: "2px solid hsl(var(--primary))",
        borderRadius: "50%",
      }}
    />
  )
}
